import * as pluralize from 'pluralize';

/**
 * Get the plural form of the word.
 *
 * @param {string} value
 * @return {string}
 */
export function plural(value: string): string {
    return pluralize.plural(value);
}

/**
 * Get the singular form of the word.
 *
 * @param {string} value
 * @return {string}
 */
export function singular(value: string): string {
    return pluralize.singular(value);
}

/**
 * Transform the first character to upper case.
 *
 * @param {string} value
 * @return {string}
 */
export function upperCaseFirst(value: string): string {
    return value && value.length > 1
        ? value.charAt(0).toUpperCase() + value.substr(1)
        : value.toUpperCase();
}

/**
 * Replace text in a string.
 *
 * @param {string} value
 * @param {string} search
 * @param {string} replace
 * @return {string}
 */
export function replace(value: string, search: string, replace: string): string {
    return value.split(search).join(replace);
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/string.ts